import { Routes, Route } from "react-router-dom";
import HomePage from "./screen/HomePage";
import Achievers from "./screen/Achievers";
import Layout from "./Layout/Layout";
import { Toaster } from "react-hot-toast";

import "flag-icons/css/flag-icons.min.css";
import BookATable from "screen/BookATable";
import Menu from "./screen/Menu";
import CartMenu from "./screen/CartMenu";
import AuthModal from "components/AuthModal/AuthModal";
import SessionExpiredModal from "./components/SectionExpiredModal/SectionExpiredModal";
import ProtectedRoute from "components/ProtectedRoute/ProtectedRoute";
import LunchMenu from "screen/LunchMenu";
import DinnerMenu from "screen/DinnerMenu";
import Checkout from "screen/Checkout";
import UserProfile from "screen/UserProfile";
import BookingList from "components/Dashboard/BookingList";
import BookingDetail from "components/Dashboard/BookingDetail";
import BookingModify from "components/Dashboard/BookingModify";
import UpdateProfile from "components/Dashboard/UpdateProfile";
import Password from "components/Dashboard/Password";
import OrderList from "components/OrderDashboard/OrderList";
import NotFound from "screen/NotFound";
import OrderDetail from "screen/OrderDetail";
import OrderDetailPage from "screen/OrderDetailPage";
import SearchPage from "screen/SearchPage";
// import BookingList from "components/Dashboard/BookingList";
// import BookingDetail from "components/Dashboard/BookingDetail";
// import BookingModify from "components/Dashboard/BookingModify";
// import UpdateProfile from "components/Dashboard/UpdateProfile";
// import Password from "components/Dashboard/Password";

function App() {
  return (
    <>
      <Toaster position="bottom-left" />
      <AuthModal />
      <SessionExpiredModal />

      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<HomePage />} />
          <Route path="/bookatable" element={<BookATable />} />
          <Route
            path="/menu"
            element={
              // <ProtectedRoute>
              <Menu />
              // </ProtectedRoute>
            }
          />
          <Route path="/menu/lunch" element={<LunchMenu />} />
          <Route path="/menu/dinner" element={<DinnerMenu />} />
          <Route path="/cart" element={<CartMenu />} />
          <Route path="/menu/lunch" element={<CartMenu />} />
          {/* //check out page */}
          <Route path="/checkout" element={<Checkout />} />
          <Route path="/search" element={<SearchPage />} />

          {/* User Profile */}

          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <UserProfile />
              </ProtectedRoute>
            }
          />

          <Route
            path="/dashboard/listoforders"
            element={
              <ProtectedRoute>
                <OrderList />{" "}
              </ProtectedRoute>
            }
          />
          <Route
            path="/orderdetail/:id"
            element={
              <ProtectedRoute>
                <OrderDetailPage />{" "}
              </ProtectedRoute>
            }
          />

          <Route path="/dashboard/profile" element={<UpdateProfile />} />
          <Route path="/dashboard/password" element={<Password />} />

          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
    </>
  );
}

export default App;
